import { render, staticRenderFns } from "./WorkflowKanbanQueue.vue?vue&type=template&id=9028533a&"
import script from "./WorkflowKanbanQueue.vue?vue&type=script&lang=ts&"
export * from "./WorkflowKanbanQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports